export default __webpack_public_path__ + "static/media/3X4A1409 (1).4ba8f904.jpg";